import { useEffect } from 'react'; import baseURL from '../url';
import { getSafeSession } from '../utils/browserSafe';
export default function FunnelTracker(){
 useEffect(()=>{const key=getSafeSession();const fd=new FormData();fd.append('eventType','visit');fd.append('sessionKey',key);fetch(`${baseURL}/funnelEvent.php`,{method:'POST',body:fd}).catch(()=>{});},[]);
 return null;
}
